/////// 新配置
//新ID 对应 !!!

export function onGetSourceProductIds() {
	//区分正式和测试
	return process.env.NODE_ENV === 'development' ? sourceProductIds : sourceProductIdsPro
}

export const sourceProductIdsPro = new Map([
	//太保制造行业
	['273', {newProductId: 49, insureType: 19}],
	//太保制造行业(佛山地区)
	['274', {newProductId: 48, insureType: 19}],
	// //太保建筑行业
	['238', {newProductId: 36, insureType: 16}],
	//阳光建筑行业
	['232', {newProductId: 38, insureType: 24}],
	//阳光制造行业
	['233', {newProductId: 37, insureType: 25}],
	//阳光运输
	['269', {newProductId: 50, insureType: 23}],
	['270', {insureType: 23}],

	//中华建筑
	['279', {newProductId: 62, insureType: 26}],
	//中华制造
	['280', {newProductId: 63, insureType: 27}],
	//大地制造行业
	['297', {newProductId: 68, insureType: 30}],

	//太保
	//太保电梯
	['318', {newProductId: 114, insureType: 21}],
	//泛高空普通版
	['324', {newProductId: 121, insureType: 6}],
	['326', {insureType: 6}],
	//泛高空尊贵版
	['325', {newProductId: 122, insureType: 6}],
	['327', {insureType: 6}],
	//泛高空年单
	['295', {newProductId: 70, insureType: 6}],
	//泛高空钢结构高伤残
	['319', {newProductId: 115, insureType: 6}],
	//泛高空钢结构低伤残
	['320', {newProductId: 116, insureType: 6}],
	//太保门窗
	['337', {newProductId: 129, insureType: 6}],
	['336', {insureType: 6}],
	//光伏
	['322', {newProductId: 117, insureType: 6}],
	['323', {insureType: 6}],
	['328', {insureType: 6}],
	['329', {insureType: 6}],
	//太保团意险
	['314', {newProductId: 113, insureType: 32}],
	//利宝
	['338', {newProductId: 310, insureType: 33}],
	['339', {newProductId: 311, insureType: 33}],

	//泰康电梯
	['97', {newProductId: 1, insureType: 18}],
	//泰康非钢结构
	['343', {newProductId: 238, insureType: 12}],
	['344', {insureType: 12}],
	//泰康钢结构
	['345', {newProductId: 240, insureType: 12}],
	['346', {insureType: 12}],
	//泰康电力
	['348', {newProductId: 242, insureType: 12}],
	['347', {insureType: 12}],
	//国寿财
	['220', {newProductId: 3, insureType: 8}],
	//美亚C款
	['304', {newProductId: 78, insureType: 13}],
	['305', {insureType: 13}],

	//平安光伏团意
	['312', {newProductId: 104, insureType: 31}],
	['313', {insureType: 31}],
])

export const sourceProductIds = new Map([
	//泛高空
	//太保电梯
	['244', {newProductId: 256, insureType: 21}],
	//泛高空普通版
	['324', {newProductId: 414, insureType: 6}],
	['326', {insureType: 6}],
	//泛高空尊贵版
	['325', {newProductId: 415, insureType: 6}],
	['327', {insureType: 6}],

	// ["308", {insureType: 6}],
	// ["309", {insureType: 6}],
	// ["310", {insureType: 6}],
	// ["311", {insureType: 6}],

	//泛高空钢结构
	['256', {newProductId: 251, insureType: 6}],
	//泛高空钢结构低伤残
	['259', {newProductId: 246, insureType: 6}],
	//光伏
	['322', {newProductId: 410, insureType: 6}],
	['323', {insureType: 6}],
	['328', {insureType: 6}],
	['329', {insureType: 6}],
	//门窗
	['261', {newProductId: 335, insureType: 6}],
	['260', {insureType: 6}],
	['306', {insureType: 6}],
	['307', {insureType: 6}],
	//太保团意险
	['314', {newProductId: 370, insureType: 32}],
	//利宝
	['338', {newProductId: 393, insureType: 33}],
	['339', {newProductId: 398, insureType: 33}],

	//泰康
	//泰康电梯
	['97', {newProductId: 153, insureType: 18}],
	//泰康非钢结构
	['298', {newProductId: 329, insureType: 12}],
	['299', {insureType: 12}],
	//泰康钢结构
	['300', {newProductId: 327, insureType: 12}],
	['301', {insureType: 12}],
	//泰康电力
	['302', {newProductId: 337, insureType: 12}],
	['303', {insureType: 12}],
	//泰康1-5
	['263', {newProductId: 368, insureType: 22}],
	['264', {insureType: 22}],
	['265', {insureType: 22}],
	['266', {insureType: 22}],

	//美亚C款
	['340', {newProductId: 408, insureType: 13}],
	['341', {insureType: 13}],
	//国寿财
	['220', {newProductId: 132, insureType: 8}],

	//平安光伏团意
	['312', {newProductId: 366, insureType: 31}],
	['313', {insureType: 31}],

	//阳光建筑行业
	['232', {newProductId: 268, insureType: 24}],
	//阳光制造行业
	['233', {newProductId: 270, insureType: 25}],
	//阳光运输行业
	['269', {newProductId: 272, insureType: 23}],
	['270', {insureType: 23}],
	//太保建筑行业
	['238', {newProductId: 257, insureType: 16}],
	//太保制造行业
	['273', {newProductId: 293, insureType: 19}],
	//太保制造行业(佛山地区)
	['274', {newProductId: 291, insureType: 19}],
	//中华建筑
	['279', {newProductId: 308, insureType: 26}],
	//中华制造
	['280', {newProductId: 309, insureType: 19}],
	//大地制造行业
	['297', {newProductId: 311, insureType: 30}],
])

export function getSourceProductId(oldProductId) {
	let tempData = onGetSourceProductIds().get(oldProductId + '')
	return tempData ? tempData.newProductId : ''
}

export function getInsureType(productId) {
	return onGetSourceProductIds().get(productId + '').insureType
}

//是否应用产品中心的详情页
export function isByCenter(oldProductId) {
	return onGetSourceProductIds().has(oldProductId + '')
}

//是否有计划书
export function isShowPlan(insureType) {
	return [6, 8, 13, 16, 18, 19, 22, 3, 12, 23, 24, 25, 26, 27, 30].includes(insureType)
}

//是否有职业类别表
export function isHasCategory(insureType) {
	return ![7, 17, 3].includes(insureType)
}

export function isSameCoverageDic(insureType) {
	return [16, 19, 24, 25, 26, 27, 30].includes(insureType)
}

//泛高空
export function isFgk(insureType) {
	return insureType == 6
}

export function isFgkTuanYi(insureType) {
	return insureType == 37
}

export function isFgk98(productId) {
	return productId == 98
}

export function isFgk99(productId) {
	return productId == 99
}

export function isFgk202(productId) {
	return productId == 202
}

//亚太
export function isYt29(productId) {
	return productId == 29
}

export function isYt30(productId) {
	return productId == 30
}

//平安光伏
export function isPingAnGuangFu(insureType) {
	return insureType == 31
}

//平安电梯
export function isPingAnDianti(insureType) {
	return insureType == 10 || insureType == 26 || insureType == 27
}

//判断家电
export function isJiaDian(insureType) {
	return insureType == 7 || insureType == 17
}

export function isJiaDian95(productId) {
	return productId == 95
}

export function isJiaDian96(productId) {
	return productId == 96
}

//不能批量替换 包含阳光
export function isNoMoreReplace(insureType) {
	return (
		// insureType != 7 &&
		// insureType != 17 &&
		//阳光
		// && insureType != 23 && insureType != 24 && insureType != 25
		//泰康
		insureType != 12 &&
		insureType != 18 &&
		insureType != 22 &&
		//三星
		insureType !== 34
	)
	//大地
	// && insureType !== 30 && insureType !== 38
}

export function isMeiYa(insureType) {
	return insureType == 13
}

//美亚 B款
export function isMeiYaB(insureType, productId) {
	return insureType == 13 && productId == 213
}

//美亚 C款
export function isMeiYaC(insureType, productId) {
	return insureType == 13 && (productId == 203 || productId == 204)
}

//新市民制造业
export function isXsmZhiZao(insureType) {
	return insureType == 19
}

//阳光运输
export function isXsmYunShu(insureType) {
	return insureType == 23
}

//制造行业-普通版本
export function isXsmZhiZaoNormal(productId) {
	return productId == 273
}

//制造行业-低费用
export function isXsmZhiZaoLowFee(productId) {
	return productId == 274
}

//新市民建筑行业
export function isXsmJianzhu(insureType) {
	return insureType == 16
}

//上海太保泛高空和电梯隐藏对公发票信息
export function isFgkZhuanpiao(insureType) {
	return insureType == 6 || insureType == 21
}

//判断是否为安责产品，需要各种条件设置，比如5万。。。this.insureType === 12 || this.insureType === 18
export function isAnZeProduct(insureType = '') {
	if (typeof insureType === 'string') {
		insureType = parseInt(insureType)
	}
	return [12, 18, 22].includes(insureType)
}

export function isAnZeDianti(insureType) {
	return insureType == 18
}

export function isAnZe15(insureType) {
	return insureType == 22
}

//安责
export function isAnZeJianzhu(insureType) {
	return insureType == 12
}

//判断家电
export function isJiaDianLong(insureType) {
	return insureType == 17
}

//建筑行业
export function isXsmJianzhuHintDialog(insureType) {
	return insureType == 16 || insureType == 24
}

export function isXsmYangguang(insureType) {
	return insureType == 14 || insureType == 24 || insureType == 23
}

//人保
export function isRenBao(insureType) {
	return insureType == 29 || insureType == 36 || insureType == 39 || insureType == 40
}

//人保电梯
export function isRenBaoDianti(insureType) {
	return insureType == 48
}

export function isFgkDianti(insureType) {
	return insureType == 21
}

//支付跳转新界面
export function isPayToNewWindow(insureType) {
	return insureType != 10 && !isGuoShouCai(insureType) && !isRenBao(insureType) && !isMeiYa(insureType)
}

export function isLibaoGuzhu(insureType) {
	return insureType == 33
}

//三星产品
export function isSanXingTuanYi(insureType) {
	return insureType == 34
}

//前海
export function isQianHai(insureType) {
	return insureType == 15
}

//国寿财
export function isGuoShouCai(insureType) {
	return insureType == 8
}

//中银
export function isZhongYin(insureType) {
	return insureType == 42 || insureType == 43
}

export function isPingAnQingDao(insureType) {
	return insureType == 41
}

export function isTaiBaoGuzhu(insureType) {
	return insureType == 32
}

export function isXsmDadi(insureType) {
	return insureType == 30 || insureType == 38
}

//你当前的保费会按照【${tempMonth}个月】收取，请仔细确认是否继续批增？ 不提醒
export function isNoHintMonth(insureType) {
	return (
		isMeiYa(insureType) ||
		isGuoShouCai(insureType) ||
		isAnZeProduct(insureType) ||
		isTaiBaoGuzhu(insureType) ||
		isSanXingTuanYi(insureType)
	)
}

//下载投保支付文件  7  16 19  6 21
export function isDownloadPayFile(insureType) {
	return insureType == 7 || insureType == 16 || insureType == 19 || insureType == 6 || insureType == 21
}

export function getEntryUrl(insureType) {
	return isRenBao(insureType) ? 'entryCenterUrl' : 'entryCenter'
}

//期限为1个月、3个月的保单不能进行人员替换，要进行人员替换请选择6个月或以上保障期限。
// 新市民建筑行业-太保、阳光、中华、大地。
export function tempHintContent(insureType) {
	return insureType == 16 || insureType == 24 || insureType == 38 || insureType == 26
}
